import { useQuery } from '@tanstack/react-query';
import { fetchFontFacesApi, fetchGlobalFonts } from '../helpers/api/customizationApi';
import { useGetAvailableFontFamilies } from './themesets';

export const FONTS_KEYS = {
  FONTFACES: 'fontfaces',
  GLOBAL_FONTS: 'globalFonts',
};

export const useGetFontFaces = () => {
  return useQuery([FONTS_KEYS.FONTFACES], () => fetchFontFacesApi(), {
    cacheTime: Infinity,
  });
};

export const useGetGlobalFonts = () => {
  const fontFamilyOptions = useGetAvailableFontFamilies();

  return useQuery([FONTS_KEYS.GLOBAL_FONTS], fetchGlobalFonts, {
    cacheTime: Infinity,
    enabled: !!fontFamilyOptions,
    select: (data) => {
      return data.filter(font => !fontFamilyOptions.includes(font.name));
    }
  });
};